import React from "react";
import { Grid } from "@mui/material";
import { InlineLabel, Toggle } from "components/common/wintForms";
import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";

type AuditorReportUploadToggleProps = {
  value: boolean;
  setValue: (value: boolean) => void | Promise<void>;
  disabled?: boolean;
};

const AuditorReportUploadToggle: React.FC<AuditorReportUploadToggleProps> = (props) => {
  const { value, setValue, disabled } = props;

  return (
    <Grid container direction="row" wrap="nowrap">
      <InlineLabel
        columns
        descriptionText={LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.AnnualAccount.AuditorReportToUploadDescription
        )}
      >
        {LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.AnnualAccount.AuditorReportToUploadDescriptionHeader
        )}
      </InlineLabel>
      <Grid item>
        <Toggle
          name="auditorReportUploadConfirmed"
          value={value}
          setValue={setValue}
          disabled={disabled ?? false}
          onChange={() => {}}
          onBlur={() => {}}
          touched
          setTouched={() => {}}
          hasError={false}
        />
      </Grid>
    </Grid>
  );
};

export default AuditorReportUploadToggle;


